import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUserGraduate,
  FaBook,
  FaCalendarAlt,
  FaCog,
  FaBus,
  FaSchool,
  FaChalkboard,
  FaLayerGroup,
  FaUsers,
  FaHome,
  FaRupeeSign,
  FaMoneyBillAlt,
  FaFileInvoiceDollar,
  FaCreditCard,
  FaBusAlt,
  FaBed,
  FaMoneyBillWave,
  FaExclamationCircle,
  FaWallet,
  FaExclamationTriangle,
  FaUserCog
} from "react-icons/fa";
import Logo from "../assets/logo.jpg";

export default function Sidebar({ isOpen }) {
  const location = useLocation();
  const [openMaster, setOpenMaster] = useState(false);
  const [openStudent, setOpenStudent] = useState(false);
  const [openFee, setOpenFee] = useState(false);
  const [openReports, setOpenReports] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  return (
    <>
      <style>{`
        .sidebar {
  width: ${isOpen ? "220px" : "70px"};
  height: 100vh;
  background: #0b1a4a;
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px 10px;
  transition: all 0.3s ease;
  overflow-y: scroll;   
  overflow-x: hidden;
}
        }
/* ===== Sidebar Scrollbar (Professional Look) ===== */

/* Chrome, Edge, Safari */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #4f46e5, #3b82f6);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* hover effect */
.sidebar::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #6366f1, #2563eb);
}

/* Firefox */
.sidebar {
  scrollbar-width: thin;
  scrollbar-color: #0b1a4a transparent;
}
        .logo {
          text-align: center;
          margin-bottom: 15px;
        }

        .logo img {
          width: ${isOpen ? "100px" : "40px"};
          transition: 0.3s;
        }

        .divider {
          height: 1px;
          background: rgba(255, 255, 255, 0.3);
          margin: 15px 0;
        }

        .admin-title {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
          letter-spacing: 1px;
          display: ${isOpen ? "block" : "none"};
        }

        .menu {
          display: flex;
          flex-direction: column;
        }

        .menu a {
          display: flex;
          align-items: center;
          gap: 10px;
          color: white;
          text-decoration: none;
          padding: 6px;
          margin-bottom: 5px;
          border-radius: 5px;
          position: relative;
        }

        .menu a:hover {
          background: #1e3a8a;
        }

        /* ✅ Active menu */
        .menu a.active {
          background: #2563eb;
        }

        .icon {
          font-size: 18px;
          min-width: 20px;
        }

        .text {
          display: ${isOpen ? "inline" : "none"};
        }

        /* ✅ Tooltip when collapsed */
        .menu a:hover::after {
          content: attr(data-name);
          position: absolute;
          left: 75px;
          background: black;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
          display: ${isOpen ? "none" : "block"};
        }

        .master-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 5px;
}

.master-title:hover {
  background: #1e3a8a;
}

.submenu {
  margin-left: 25px;
  display: flex;
  flex-direction: column;
}

.submenu a {
  font-size: 14px;
  padding: 5px;
  color: #cbd5f5;
  text-decoration: none;
  border-radius: 5px;
}

.submenu a:hover {
  background: #1e40af;
}
      `}</style>

      <div className="sidebar">
        {/* 🔷 LOGO */}
        <div className="logo">
          <img src={Logo} alt="School Logo" />
        </div>

        {/* 🔷 DIVIDER */}
        <div className="divider"></div>

        {/* 🔷 TITLE */}
        <div className="admin-title">Admin Panel</div>

        {/* 🔷 MENU */}
        <nav className="menu">
          <Link
            to="/admin/dashboard"
            className={location.pathname.includes("dashboard") ? "active" : ""}
            data-name="Dashboard"
          >
            <FaTachometerAlt className="icon" />
            <span className="text">Dashboard</span>
          </Link>

          {/*  MASTER DATA DROPDOWN */}
          <div
            className="master-title"
            onClick={() => setOpenMaster(!openMaster)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaBook className="icon" />
              <span className="text">Master Data</span>
            </div>

            {isOpen && (
              <span style={{ fontSize: "12px" }}>
                {openMaster ? "▼" : "▶"}
              </span>
            )}
          </div>

          {openMaster && isOpen && (
            <div className="submenu">

              <Link
                to="/admin/schoolinfo"
                className={location.pathname.includes("schoolinfo") ? "active" : ""}
                data-name="School Info"
              >
                <FaSchool className="icon" />
                <span className="text">School Info</span>
              </Link>

              <Link
                to="/admin/session"
                className={location.pathname.includes("session") ? "active" : ""}
                data-name="Session"
              >
                <FaCalendarAlt className="icon" />
                <span className="text">Session</span>
              </Link>

              <Link
                to="/admin/class"
                className={location.pathname.includes("class") ? "active" : ""}
                data-name="Class"
              >
                <FaChalkboard className="icon" />
                <span className="text">Class</span>
              </Link>

              <Link
                to="/admin/section"
                className={location.pathname.includes("section") ? "active" : ""}
                data-name="Section"
              >
                <FaLayerGroup className="icon" />
                <span className="text">Section</span>
              </Link>

              <Link
                to="/admin/group"
                className={location.pathname.includes("group") ? "active" : ""}
                data-name="Group"
              >
                <FaUsers className="icon" />
                <span className="text">Group</span>
              </Link>

              <Link
                to="/admin/house"
                className={location.pathname.includes("house") ? "active" : ""}
                data-name="House"
              >
                <FaHome className="icon" />
                <span className="text">House</span>
              </Link>

              <Link
                to="/admin/feesetup"
                className={location.pathname.includes("feesetup") ? "active" : ""}
                data-name="Fee Setup"
              >
                <FaRupeeSign className="icon" />
                <span className="text">Fee Setup</span>
              </Link>

              <Link
                to="/admin/classfee"
                className={location.pathname.includes("classfee") ? "active" : ""}
                data-name="Class Fee"
              >
                <FaMoneyBillAlt className="icon" />
                <span className="text">Class Fee</span>
              </Link>

              <Link
                to="/admin/groupfee"
                className={location.pathname.includes("groupfee") ? "active" : ""}
                data-name="Group Fee"
              >
                <FaFileInvoiceDollar className="icon" />
                <span className="text">Group Fee</span>
              </Link>

              <Link
                to="/admin/transportroute"
                className={location.pathname.includes("transportroute") ? "active" : ""}
                data-name="Transport Route"
              >
                <FaBus className="icon" />
                <span className="text">Transport Route</span>
              </Link>

              <Link
                to="/admin/paymode"
                className={location.pathname.includes("paymode") ? "active" : ""}
                data-name="Pay Mode"
              >
                <FaCreditCard className="icon" />
                <span className="text">Pay Mode</span>
              </Link>

            </div>
          )}

          {/* 🔽 STUDENT INFORMATION DROPDOWN */}
          <div
            className="master-title"
            onClick={() => setOpenStudent(!openStudent)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaUserGraduate className="icon" />
              <span className="text">Student Info</span>
            </div>

            {isOpen && (
              <span style={{ fontSize: "12px" }}>
                {openStudent ? "▼" : "▶"}
              </span>
            )}
          </div>

          {openStudent && isOpen && (
            <div className="submenu">

              <Link
                to="/admin/students"
                className={location.pathname.includes("students") ? "active" : ""}
                data-name="Students"
              >
                <FaUserGraduate className="icon" />
                <span className="text">Student List</span>
              </Link>

              <Link
                to="/admin/studenttransport"
                className={location.pathname.includes("studenttransport") ? "active" : ""}
                data-name="Student Transport"
              >
                <FaBusAlt className="icon" />
                <span className="text">Student Transport</span>
              </Link>

              <Link
                to="/admin/studenthostel"
                className={location.pathname.includes("studenthostel") ? "active" : ""}
                data-name="Student Hostel"
              >
                <FaBed className="icon" />
                <span className="text">Student Hostel</span>
              </Link>

            </div>
          )}

          {/* 🔽 FEE DROPDOWN */}
          <div
            className="master-title"
            onClick={() => setOpenFee(!openFee)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaRupeeSign className="icon" />
              <span className="text">Fee</span>
            </div>

            {isOpen && (
              <span style={{ fontSize: "12px" }}>
                {openFee ? "▼" : "▶"}
              </span>
            )}
          </div>

          {openFee && isOpen && (
            <div className="submenu">
              <Link to="/admin/collectfees">
                <FaMoneyBillWave className="icon" />
                <span className="text">Collect Fees</span>
              </Link>

              <Link to="/admin/unsettledfees">
                <FaExclamationCircle className="icon" />
                <span className="text">Unsettled Fees</span>
              </Link>
            </div>
          )}

          {/* 🔽 REPORTS DROPDOWN */}
          <div
            className="master-title"
            onClick={() => setOpenReports(!openReports)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaFileInvoiceDollar className="icon" />
              <span className="text">Reports</span>
            </div>

            {isOpen && (
              <span style={{ fontSize: "12px" }}>
                {openReports ? "▼" : "▶"}
              </span>
            )}
          </div>

          {openReports && isOpen && (
            <div className="submenu">
              <Link to="/admin/studentgroupwise">
                <FaUsers className="icon" />
                <span className="text">Student Group Wise</span>
              </Link>

              <Link to="/admin/feecollection">
                <FaWallet className="icon" />
                <span className="text">Fee Collection</span>
              </Link>

              <Link to="/admin/fcpaymode">
                <FaCreditCard className="icon" />
                <span className="text">FC Pay Mode Wise</span>
              </Link>

              <Link to="/admin/fcoutstanding">
                <FaExclamationTriangle className="icon" />
                <span className="text">FC Out Standing</span>
              </Link>
            </div>
          )}


          {/* 🔽 SETTINGS DROPDOWN */}
          <div
            className="master-title"
            onClick={() => setOpenSettings(!openSettings)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaCog className="icon" />
              <span className="text">Settings</span>
            </div>

            {isOpen && (
              <span style={{ fontSize: "12px" }}>
                {openSettings ? "▼" : "▶"}
              </span>
            )}
          </div>

          {openSettings && isOpen && (
            <div className="submenu">
              <Link to="/admin/user">
                <FaUserCog className="icon" />
                <span className="text">User</span>
              </Link>
            </div>
          )}

        </nav>
      </div>
    </>
  );
}